import styled from "styled-components";
import { motion } from "framer-motion";

import { FlexDiv } from "@/components/Atoms/Box";

import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

export const PageWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(min-content, 680px);
  box-sizing: border-box;
  @media only screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const BannerContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  background-image: url("${process.env
    .PUBLIC_URL}/images/diwali-banner-web.jpg");
  background-position-x: left;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 148px 105px 354px 173px;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #370980;
    opacity: 0.6;
    mix-blend-mode: lighten;
  }
  @media only screen and (max-width: 600px) {
    background-image: url("${process.env
      .PUBLIC_URL}/images/diwali-banner-mobile.jpg");
    background-position: center;
    background-size: cover;
    padding: 54px 22px 270px 22px;
    align-items: center;
  }
`;
export const BottomContainer = styled.div`
  background-color: ${theme.colorsV2.shyft.purple_text};
  padding: 115px 99px 123px 100px;
  grid-column-start: 1;
  grid-column-end: 3;
  box-sizing: border-box;
  margin-bottom: 1px;
  box-sizing: border-box;
  background-image: url("${process.env
    .PUBLIC_URL}/images/festival-banner-bottm-banner.png");
  background-repeat: no-repeat;
  background-position: right bottom;
  background-attachment: absolute;
  background-size: cover;
  background-size: 303px 292px;
  @media only screen and (max-width: 600px) {
    grid-column-start: 1;
    grid-column-end: 2;
    padding: 56px 32px;
    background-image: url("${process.env
      .PUBLIC_URL}/images/festival-banner-bottm-banner-mobile.png");
    background-size: 140px 437px;
  }
`;
export const FormContainer = styled.div`
  background-color: #ffffff;
`;

export const FormBanner = styled.div`
  height: 100%;
  background-color: ${theme.colorsV2.warning.shade_100};
  padding: 148px 100px 42px 65px;
  background-image: url("${process.env.PUBLIC_URL}/images/note-favorite.png");
  background-repeat: no-repeat;
  background-position: right bottom;
  background-attachment: absolute;
  background-size: cover;
  background-size: 187px;
  @media only screen and (max-width: 600px) {
    padding: 32px;
    background-size: 110px;
  }
`;

export const BottomGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 88px;
  @media only screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const BottomGridItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
`;

export const FormBox = styled.div`
  padding: 62px 100px 0px 65px;
  @media only screen and (max-width: 600px) {
    padding: 32px 16px 0px;
    margin-top: 20px;
  }
`;

export const ButtonBox = styled.div`
  padding: 10px 20px 20px 20px;
  display: flex;
  justify-content: flex-start;
  @media only screen and (max-width: 600px) {
    display: block;
  }
`;

export const FormSubmitMessageContainer = styled(motion.div)`
  padding: 22px 40px;
  background-color: ${theme.colorsV2.success.shade_50};
  border-radius: 20px;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 600px) {
    padding: 20px;
    border-radius: 12px;
  }
`;

export const ButtonsWrapper = styled(FlexDiv)`
  align-items: center;
  gap: 24px;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Title = styled(Typography)`
  @media only screen and (max-width: 600px) {
    text-align: center;
  }
`;

export const SubTitle = styled(Typography)`
  @media only screen and (max-width: 600px) {
    text-align: center;
  }
`;

export const FormTitle = styled(Typography)`
  @media only screen and (max-width: 600px) {
    text-align: center;
  }
`;
